/* eslint-disable react/no-array-index-key */
import { css, jsx } from '@emotion/core';
import moment from 'moment';
import Link from 'next/link';
import PropTypes from 'prop-types';
import React from 'react';

import Heading from '@/src/shared/components/Heading';
import { colors } from '@/styles';

const styles = {
  eventContainer: css`
    margin-top: 27.5px;
    display: flex;
    flex-direction: column;
    &:first-of-type {
      margin-top: 0;
    }
  `,
  tag: css`
    color: ${colors.secondaryGray};
    font-size: 1.2rem;
    line-height: 20px;
    font-weight: 900;
    text-transform: uppercase;
    &::after {
      content: '|';
      padding: 0 5px;
      display: inline-block;
    }
    &:last-child {
      &::after {
        display: none;
      }
    }
  `,
  tagContainer: css`
    display: flex;
  `,
};

/**
 * @param {string} start - start date MM/DD/YYYY LTS
 * @param {string} end - end date MM/DD/YYYY LTS
 * @returns {string} formatted date range or date
 */
function getTitle(start, end) {
  const DATE_FORMAT = 'MMMM DD, YYYY';

  const startDate = moment.utc(start).local();
  const endDate = moment.utc(end).local();

  if (startDate.date() === endDate.date()) {
    return startDate.format(DATE_FORMAT);
  }
  if (startDate.month() !== endDate.month()) {
    return startDate.year() !== endDate.year()
      ? `${startDate.format('MMMM DD')}-${endDate.format(DATE_FORMAT)}`
      : `${startDate.format(DATE_FORMAT)}-${endDate.format(DATE_FORMAT)}`;
  }
  return `${startDate.format('MMMM DD')}-${endDate.format('DD, YYYY')}`;
}

const Event = ({ event }) => (
  <div css={styles.eventContainer}>
    <Link href={`/events/meetings/meeting/${event.SitePageId}`}>
      <a>
        <Heading type={4} weight="bolder" theme="primaryBlue">
          {event.PageTitle}
        </Heading>
      </a>
    </Link>
    <div>
      <span css={styles.tag}>{getTitle(event.MeetingStartDate, event.MeetingEndDate)}</span>
      {event.MeetingLocation ? <span css={styles.tag}>{event.MeetingLocation}</span> : ''}
    </div>
  </div>
);

Event.propTypes = {
  event: PropTypes.shape({
    SitePageId: PropTypes.number,
    Cat1Id: PropTypes.number,
    PageTitle: PropTypes.string,
    DateModified: PropTypes.string,
    PublicationMasterCode: PropTypes.number,
    PublicationMaster: PropTypes.string,
    PublishDate: PropTypes.string,
    MeetingStartDate: PropTypes.string,
    MeetingEndDate: PropTypes.string,
    MeetingLocationId: PropTypes.number,
    MeetingLocation: PropTypes.string,
    ExecutiveSummary: PropTypes.string,
    IconId: PropTypes.number,
    Icon: PropTypes.string,
  }).isRequired,
};

export default Event;
